import React from 'react';
import '../styles/NumberedBadge.css';

interface NumberedBadgeProps {
  number: string;
  text: string;
  isDark?: boolean;
}

const NumberedBadge: React.FC<NumberedBadgeProps> = ({ number, text, isDark }) => {
  return (
    <div className={`numbered-item ${isDark ? 'numbered-item-dark' : ''}`}>
      <div className="number-badge">{number}</div>
      <span className="item-text">{text}</span>
    </div>
  );
};

export default NumberedBadge;
